// Operator bulk-import of existing homecare clients (agency absorption +
// staging tester load). Per Convention 06 (per-resource schema file).
//
// Unlike caregivers, a homecare client is AUTO-ACTIVE on creation (B1 reversal),
// so the import creates a usable account immediately; the client still completes
// the Client agreement + card-on-file before the first booking (gated at booking
// time). Each row = one account holder + one recipient (the common case). The
// welcome magic-link is always sent (the signup path bundles it) — there is no
// silent-load option here.
//
// `recipient` reuses RecipientCreateRequestSchema verbatim (no validator drift);
// the account-holder fields mirror the public signup shape MINUS honeypot /
// turnstile / paymentMode (operator-authed; paymentMode is forced to STRIPE).
import { z } from 'zod';
import { RecipientCreateRequestSchema } from './self.schema.js';
export const HomecareImportRowSchema = z.object({
    email: z.string().email().max(254).toLowerCase(),
    displayName: z.string().min(1).max(120).trim(),
    phone: z.string().min(10).max(30).trim(),
    recipient: RecipientCreateRequestSchema,
});
export const HomecareImportRequestSchema = z.object({
    rows: z.array(HomecareImportRowSchema).min(1).max(500),
    /** Validate + report the per-row plan WITHOUT writing anything or sending any
     *  email / creating any Stripe customer. */
    dryRun: z.boolean().default(false),
});
export const HomecareImportRowResultSchema = z.object({
    email: z.string(),
    /** created = new auto-active client + recipient (or, in dryRun, would be);
     *  skipped = a homecare client already exists for this email (idempotent);
     *  failed  = validation or a write error for this row (others still proceed). */
    status: z.enum(['created', 'skipped', 'failed']),
    clientId: z.string().nullable(),
    reason: z.string().nullable(),
});
export const HomecareImportResponseSchema = z.object({
    dryRun: z.boolean(),
    summary: z.object({
        total: z.number().int(),
        created: z.number().int(),
        skipped: z.number().int(),
        failed: z.number().int(),
    }),
    results: z.array(HomecareImportRowResultSchema),
});
//# sourceMappingURL=import.schema.js.map